import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCart, useCartStatusEffect } from 'b2b-apps/shop/cart/hooks';
import { fetchCart } from 'b2b-apps/shop/cart/redux/cart/actionCreators';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { CartStatusType, CartType } from 'b2b-common/core/cart/api/CartTypes';

export type UseCartWithStatusReturnType = {
  cart: RemoteRecord<CartType>;
  cartStatus: CartStatusType;
};

export const useCartWithStatus = (): UseCartWithStatusReturnType => {
  const cart = useCart();
  const cartStatus = useCartStatusEffect();
  const dispatch = useDispatch();
  const { isLastInsertedNewItem } = cartStatus;

  useEffect((): void => {
    if (isLastInsertedNewItem) {
      dispatch(fetchCart());
    }
  }, [dispatch, isLastInsertedNewItem]);

  return { cart, cartStatus };
};
